import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import api from '../../api/axios.js';
import { FiUserCheck, FiUsers, FiTrendingUp, FiClock, FiAlertCircle, FiDollarSign, FiGift, FiPercent } from 'react-icons/fi';

/* ✅ FULL INDIA STATES WITH ALL DEFAULT */
const STATES = [
  { label: "All States", value: "all" },
  { label: "Andhra Pradesh", value: "andhra pradesh" },
  { label: "Arunachal Pradesh", value: "arunachal pradesh" },
  { label: "Assam", value: "assam" },
  { label: "Bihar", value: "bihar" },
  { label: "Chhattisgarh", value: "chhattisgarh" },
  { label: "Goa", value: "goa" },
  { label: "Gujarat", value: "gujarat" },
  { label: "Haryana", value: "haryana" },
  { label: "Himachal Pradesh", value: "himachal pradesh" },
  { label: "Jharkhand", value: "jharkhand" },
  { label: "Karnataka", value: "karnataka" },
  { label: "Kerala", value: "kerala" },
  { label: "Madhya Pradesh", value: "madhya pradesh" },
  { label: "Maharashtra", value: "maharashtra" },
  { label: "Manipur", value: "manipur" },
  { label: "Meghalaya", value: "meghalaya" },
  { label: "Mizoram", value: "mizoram" },
  { label: "Nagaland", value: "nagaland" },
  { label: "Odisha", value: "odisha" },
  { label: "Punjab", value: "punjab" },
  { label: "Rajasthan", value: "rajasthan" },
  { label: "Sikkim", value: "sikkim" },
  { label: "Tamil Nadu", value: "tamil nadu" },
  { label: "Telangana", value: "telangana" },
  { label: "Tripura", value: "tripura" },
  { label: "Uttar Pradesh", value: "uttar pradesh" },
  { label: "Uttarakhand", value: "uttarakhand" },
  { label: "West Bengal", value: "west bengal" },
  { label: "Delhi", value: "delhi" },
  { label: "Jammu & Kashmir", value: "jammu and kashmir" },
  { label: "Ladakh", value: "ladakh" },
  { label: "Chandigarh", value: "chandigarh" },
  { label: "Puducherry", value: "puducherry" },
  { label: "Andaman & Nicobar", value: "andaman and nicobar" },
  { label: "Dadra & Nagar Haveli", value: "dadra and nagar haveli" },
  { label: "Daman & Diu", value: "daman and diu" },
  { label: "Lakshadweep", value: "lakshadweep" }
];

const Dashboard = () => {
  /* ================= ADVISOR TABLE STATE ================= */
  const [advisors, setAdvisors] = useState([]);
  const [role, setRole] = useState("advisor-district-coordinator");
  const [state, setState] = useState("all");
  const [usersState, setUsersState] = useState("all")
  const [overallTotalRevenue,setOverAllTotalRevenue]=useState(0)
  const [usersData, setUsersData] = useState({
  customers: 0,
  vendors: 0,
  advisors: 0
});
  const [extStats, setExtStats] = useState({
  activeVendors: 0,
  expiredVendors: 0,
  totalLeads: 0,
  gstCollection: 0,
  referralPayout: 0,
  pendingApprovals: 0,
});
  const [page, setPage] = useState(1);
  const limit = 10;
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  /* ================= REVENUE GRAPH STATE ================= */
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 30 }, (_, i) => currentYear - i);

  // filter type: "monthly" | "yearly" | "range"
  const [filterType, setFilterType] = useState("monthly");
  const [year, setYear] = useState(currentYear.toString());          // monthly mode
  const [month, setMonth] = useState("all");                         // monthly mode (all | 1..12)
  const [yearFrom, setYearFrom] = useState((currentYear - 5).toString()); // yearly mode
  const [yearTo, setYearTo] = useState(currentYear.toString());      // yearly mode
  const [fromDate, setFromDate] = useState("");                      // range mode
  const [toDate, setToDate] = useState("");                          // range mode

  // chart data is now generic: array of { label, value }
  const [chartData, setChartData] = useState([]);
  const [revenueLoading, setRevenueLoading] = useState(false);

  const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];


  const fetchUsersByState = async () => {
  try {
    console.log(usersState,"us")
    const res = await api.get("/admin/state-wise/users", {
      params: {
        ...(usersState !== "all" && { state: usersState })
      }
    });

    if (res.data.success) {
      const summary =
        usersState !== "all"
          ? res.data.stateSummary
          : res.data.overallSummary;

      setUsersData({
        customers: summary?.totalCustomers || 0,
        vendors: summary?.totalVendors || 0,
        advisors: summary?.totalAdvisors || 0
      });
    }
  } catch (err) {
    console.error("State-wise users fetch error", err);
  }
}

  /* ================= FETCH EXTENDED STATS ================= */
  const fetchExtStats = async () => {
    try {
      const res = await api.get('/admin/dashboard');
      if (res.data?.success) {
        const d = res.data.data;
        setExtStats({
          activeVendors: d.activeVendors || 0,
          expiredVendors: d.expiredVendors || 0,
          totalLeads: d.totalLeads || 0,
          gstCollection: d.gstCollection || 0,
          referralPayout: d.referralPayout || 0,
          pendingApprovals: d.pendingApprovals || 0,
        });
        setUsersData(prev => ({
          ...prev,
          vendors: d.totalVendors || prev.vendors,
          customers: d.totalCustomers || prev.customers,
        }));
        setOverAllTotalRevenue(d.totalRevenue || 0);
      }
    } catch (err) {
      console.error('Admin dashboard stats fetch error', err);
    }
  };

  /* ================= FETCH ADVISORS ================= */
  const fetchAdvisors = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/all-users", {
        params: {
          userType: role,
          ...(state !== "all" && { state }),
          page,
          limit
        }
      });

      if (res.data.success) {
        setAdvisors(res.data.data);
        setPagination(res.data.pagination);
      }
    } catch (err) {
      console.error("Advisor fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FETCH REVENUE (per year, 12 months) ================= */
  // Reusable helper: returns a 12-length array of month totals for a given year.
  const fetchYearMonthly = async (yr) => {
    const arr = Array(12).fill(0);
    try {
      const res = await api.get(`/admin/payments/monthly-revenue`, { params: { year: yr } });
      if (res.data?.success && Array.isArray(res.data.data)) {
        res.data.data.forEach(item => {
          if (item.month >= 1 && item.month <= 12) {
            arr[item.month - 1] = item.totalRevenue || 0;
          }
        });
      }
    } catch (err) {
      console.error("Monthly revenue fetch error", yr, err);
    }
    return arr;
  };

  /* ================= FETCH REVENUE GRAPH (filter aware) ================= */
  const fetchRevenue = async () => {
    setRevenueLoading(true);
    try {
      let result = [];

      if (filterType === "monthly") {
        /* ---- Monthly: 12 bars for the year, or a single selected month ---- */
        const arr = await fetchYearMonthly(year);
        if (month === "all") {
          result = arr.map((v, i) => ({ label: monthNames[i], value: v }));
        } else {
          const idx = Number(month) - 1;
          result = [{ label: `${monthNames[idx]} ${year}`, value: arr[idx] || 0 }];
        }

      } else if (filterType === "yearly") {
        /* ---- Yearly: one bar per year in [yearFrom, yearTo] ---- */
        const start = Math.min(Number(yearFrom), Number(yearTo));
        const end = Math.max(Number(yearFrom), Number(yearTo));
        const yrs = [];
        for (let y = start; y <= end; y++) yrs.push(y);
        const totals = await Promise.all(
          yrs.map(async (y) => (await fetchYearMonthly(y)).reduce((a, b) => a + b, 0))
        );
        result = yrs.map((y, i) => ({ label: String(y), value: totals[i] }));

      } else if (filterType === "range") {
        /* ---- Date range: bars per month between fromDate and toDate ---- */
        if (!fromDate || !toDate) {
          setChartData([]);
          setRevenueLoading(false);
          return;
        }

        let handled = false;

        // 1) Try a dedicated backend endpoint first (if it exists)
        try {
          const res = await api.get(`/admin/payments/revenue`, {
            params: { startDate: fromDate, endDate: toDate, groupBy: "month" }
          });
          if (res.data?.success && Array.isArray(res.data.data) && res.data.data.length) {
            result = res.data.data.map(item => ({
              label: item.label ||
                `${monthNames[((item.month || 1) - 1)]} ${String(item.year || "").slice(2)}`.trim(),
              value: item.totalRevenue ?? item.value ?? 0
            }));
            handled = true;
          }
        } catch (e) {
          // backend doesn't support this endpoint -> fall back to frontend aggregation
        }

        // 2) Frontend fallback: aggregate using the working monthly-revenue endpoint
        if (!handled) {
          const from = new Date(fromDate);
          const to = new Date(toDate);
          const months = [];
          let d = new Date(from.getFullYear(), from.getMonth(), 1);
          const last = new Date(to.getFullYear(), to.getMonth(), 1);
          while (d <= last) {
            months.push({ year: d.getFullYear(), month: d.getMonth() });
            d = new Date(d.getFullYear(), d.getMonth() + 1, 1);
          }

          const uniqueYears = [...new Set(months.map(m => m.year))];
          const yearData = {};
          await Promise.all(
            uniqueYears.map(async (y) => { yearData[y] = await fetchYearMonthly(y); })
          );

          result = months.map(m => ({
            label: `${monthNames[m.month]} ${String(m.year).slice(2)}`,
            value: yearData[m.year]?.[m.month] || 0
          }));
        }
      }

      // Note: the "Revenue" stat card above always reflects the true
      // all-time total from fetchExtStats() (/admin/dashboard) — it must
      // not be overwritten here with this chart's (filtered) period sum.
      setChartData(result);
    } catch (err) {
      console.error("Revenue fetch error", err);
      setChartData([]);
    } finally {
      setRevenueLoading(false);
    }
  };

  /* ================= EFFECTS ================= */
  useEffect(() => {
    fetchAdvisors();
  }, [role, state, page]);

  useEffect(() => {
    fetchUsersByState();
  }, [usersState]);

  useEffect(() => {
    fetchExtStats();
  }, []);

  useEffect(() => {
    fetchRevenue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterType, year, month, yearFrom, yearTo, fromDate, toDate]);

  /* ================= BAR GRAPH SCALE (dynamic) ================= */
  // Round a value up to a "nice" number so the y-axis looks clean.
  const niceMax = (v) => {
    if (!v || v <= 0) return 1000;
    const pow = Math.pow(10, Math.floor(Math.log10(v)));
    return Math.ceil(v / pow) * pow;
  };

  const maxVal = chartData.reduce((m, d) => Math.max(m, d.value || 0), 0);
  const yMax = niceMax(maxVal);
  const yStep = yMax / 10;

  // A month with real (but small) revenue next to a much larger one — e.g. a
  // single ₹15 month next to a ₹3,600 month — scales to a sub-pixel bar and
  // reads as "no data", making the chart look like it stops dead at the
  // tallest bar. Floor any non-zero value to a minimum visible height so
  // every period with revenue actually shows a bar.
  const MIN_BAR_PX = 4;
  const barHeightPx = (value) => {
    if (!value || value <= 0) return 0;
    return Math.max((value / yMax) * 200, MIN_BAR_PX);
  };

  const formatK = (num) => {
    // strip floating-point noise (e.g. 1.4000000000000001 -> 1.4)
    const n = Math.round(num * 100) / 100;
    if (Math.abs(n) >= 1000) {
      const k = n / 1000;
      return `${Number(k.toFixed(1))}k`;
    }
    return `${Number(n.toFixed(2))}`;
  };

  return (
    <div className="dashboard">

      {/* ================= STATS ================= */}
      <div className="stats-grid stats-grid-extended">
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Total Vendors</h3><p className="stat-value">{usersData.vendors}</p></div>
            <div className="stat-icon vendors"><FiUsers /></div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Active Vendors</h3><p className="stat-value">{extStats.activeVendors}</p></div>
            <div className="stat-icon vendors"><FiTrendingUp /></div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Expired Vendors</h3><p className="stat-value">{extStats.expiredVendors}</p></div>
            <div className="stat-icon advisor"><FiClock /></div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Total Customers</h3><p className="stat-value">{usersData.customers}</p></div>
            <div className="stat-icon customers"><FiUsers /></div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Total Leads</h3><p className="stat-value">{extStats.totalLeads}</p></div>
            <div className="stat-icon vendors"><FiAlertCircle /></div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Revenue</h3><p className="stat-value">₹{Number(overallTotalRevenue || 0).toLocaleString('en-IN')}</p></div>
            <div className="stat-icon revenue">₹</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>GST Collection</h3><p className="stat-value">₹{Number(extStats.gstCollection || 0).toLocaleString('en-IN')}</p></div>
            <div className="stat-icon revenue"><FiPercent /></div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Referral Payout</h3><p className="stat-value">₹{Number(extStats.referralPayout || 0).toLocaleString('en-IN')}</p></div>
            <div className="stat-icon advisor"><FiGift /></div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-content stc2">
            <div className="stat-info"><h3>Pending Approvals</h3><p className="stat-value">{extStats.pendingApprovals}</p></div>
            <div className="stat-icon customers"><FiAlertCircle /></div>
          </div>
        </div>
      </div>

      {/* ================= BAR GRAPH ================= */}
      <div className="chart-section">
        <div className="chart-header">
          <h2>Revenue Overview</h2>
          <div className="chart-controls">
            {/* Filter type */}
            <select
              className="chart-select"
              value={filterType}
              onChange={e => setFilterType(e.target.value)}
            >
              <option value="monthly">Monthly</option>
              <option value="yearly">Yearly</option>
              <option value="range">Date Range</option>
            </select>

            {/* Monthly -> year + month */}
            {filterType === "monthly" && (
              <>
                <select className="chart-select" value={year} onChange={e => setYear(e.target.value)}>
                  {years.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
                <select className="chart-select" value={month} onChange={e => setMonth(e.target.value)}>
                  <option value="all">All Months</option>
                  {monthNames.map((m, i) => (
                    <option key={m} value={i + 1}>{m}</option>
                  ))}
                </select>
              </>
            )}

            {/* Yearly -> from year / to year */}
            {filterType === "yearly" && (
              <>
                <select className="chart-select" value={yearFrom} onChange={e => setYearFrom(e.target.value)}>
                  {years.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
                <span className="chart-control-sep">to</span>
                <select className="chart-select" value={yearTo} onChange={e => setYearTo(e.target.value)}>
                  {years.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </>
            )}

            {/* Date range -> from date / to date */}
            {filterType === "range" && (
              <>
                <input
                  type="date"
                  className="chart-select"
                  value={fromDate}
                  max={toDate || undefined}
                  onChange={e => setFromDate(e.target.value)}
                />
                <span className="chart-control-sep">to</span>
                <input
                  type="date"
                  className="chart-select"
                  value={toDate}
                  min={fromDate || undefined}
                  onChange={e => setToDate(e.target.value)}
                />
              </>
            )}
          </div>
        </div>

        <div className="chart-container">
          {revenueLoading ? (
            <div className="chart-empty">Loading...</div>
          ) : filterType === "range" && (!fromDate || !toDate) ? (
            <div className="chart-empty">Select a "from" and "to" date to view revenue.</div>
          ) : chartData.length === 0 ? (
            <div className="chart-empty">No revenue data for the selected filter.</div>
          ) : (
            <>
              <div className="chart">
                <div className="chart-bars">
                  {chartData.map((d, i) => (
                    <div key={i} className="chart-bar-container">
                      {d.value > 0 && (
                        <span className="chart-bar-value">{formatK(d.value)}</span>
                      )}
                      <div
                        className="chart-bar"
                        style={{ height: `${barHeightPx(d.value)}px` }}
                        title={`₹${(d.value || 0).toLocaleString('en-IN')}`}
                      />
                      <span className="chart-label">{d.label}</span>
                    </div>
                  ))}
                </div>

                <div className="chart-y-axis">
                  {Array.from({ length: 11 }, (_, i) => yStep * (10 - i)).map((val, idx) => (
                    <span key={idx}>{formatK(val)}</span>
                  ))}
                </div>
              </div>
              <div className="chart-x-label">
                {filterType === "monthly" ? "Months" : filterType === "yearly" ? "Years" : "Period"}
              </div>
            </>
          )}
        </div>
      </div>

      {/* ================= BOTTOM SECTION ================= */}
      <div className="bottom-section">


        <div className="advisors-table" style={{width:'650px'}}>
          <div className="table-header">
            <h3>📄 All Advisor</h3>
            <div className="table-controls">
              <select className="table-select" value={role} onChange={e=>setRole(e.target.value)}>
                <option value="advisor-district-coordinator">District Coordinator</option>
                <option value="advisor-commisionerate">Commissionery Manager</option>
                <option value="advisor-state-head">State Head</option>
              </select>
              <select className="table-select" value={state} onChange={e=>setState(e.target.value)}>
                {STATES.map(s=>(
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="table-container">
            <div className="table-wrapper">
              <table className="advisors-table-content">
                <thead>
                  <tr>
                    <th>Advisor Name</th>
                    <th>Bank Name</th>
                    <th>Account Holder</th>
                    <th>Account Number</th>
                    <th>IFSC</th>
                    <th>Salary</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="6" align="center">Loading...</td></tr>
                  ) : advisors.length === 0 ? (
                    <tr><td colSpan="6" align="center">No data</td></tr>
                  ) : advisors.map(a=>(
                    <tr key={a._id}>
                      <td>{a.name}</td>
                      <td>{a.bank_details?.bank_name || "-"}</td>
                      <td>{a.bank_details?.account_holder_name || "-"}</td>
                      <td>{a.bank_details?.account_number || "-"}</td>
                      <td>{a.bank_details?.ifsc_code || "-"}</td>
                      <td>{a.salary}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pagination">
            <button disabled={page===1} onClick={()=>setPage(p=>p-1)}>Prev</button>
            <span>{page} / {pagination.totalPages || 1}</span>
            <button disabled={page===pagination.totalPages} onClick={()=>setPage(p=>p+1)}>Next</button>
          </div>
        </div>

        <div className="users-chart">
          <div className="users-header">
            <h3>All Users</h3>
            <select className="users-select"  
            value={usersState}         
             onChange={e => setUsersState(e.target.value)} >
              {STATES.map(s=>(
                <option key={s.value} value={s.value}>{s.label}</option>
              ))}
            </select>
          </div>

          <div className="donut-chart">
            <div className="donut-segments">
              <div className="segment customers" data-value="22"> {usersData.customers} </div>
              <div className="segment vendors" data-value="48"> {usersData.vendors} </div>
              <div className="segment-advisors" data-value="12">{usersData.advisors}</div>
            </div>
          </div>

          <div className="chart-legend">
            <div className="legend-item">
              <span className="legend-color customers"></span>
              <span>Customers</span>
              <span className="legend-value">{usersData.customers} </span>
            </div>
            <div className="legend-item">
              <span className="legend-color vendors"></span>
              <span>Vendors</span>
              <span className="legend-value">{usersData.vendors}</span>
            </div>
            <div className="legend-item">
              <span className="legend-color advisors"></span>
              <span>Advisor</span>
              <span className="legend-value">{usersData.advisors}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
